module.exports = __webpack_public_path__ + "static/media/building.3f383b31.jpeg";